export function loadFont(name: string, url: string) {
  url = url.startsWith('/') ? url : '/' + url;
  const newFont = new FontFace(name, `url(${url})`);
  newFont.load().then(function (loaded) {
    document.fonts.add(loaded);
  }).catch(function (error) {
    return error;
  });
}